import { store } from '@/store';
const MainHeader = () => import('@/components/MainHeader');
const Otp = () => import('@/views/common/checkout/Otp');
const Finish = () => import('@/views/common/checkout/Finish');
const Payment = () => import('@/views/common/checkout/Payment');
const Pending = () => import('@/views/common/checkout/Pending');
const MidConfirm = () => import('@/views/common/mid/Confirm');
const MidPreview = () => import('@/views/common/mid/Preview');

/**
 * 保費試算流程
 */
export default [
    {
        // 付款前 OTP
        path: '/:type(car|motor)/checkout/otp',
        name: 'CarCheckoutOtp',
        components: {
            default: Otp,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                return next(from);
            } else if (!store.getters['otp/loginOtpCodeAvailable']) { // 如果 OTP 已超時，導回保單預覽
                return next(`/${to.params.type}/insure/${store.state.policy.type}/review`);
            }

            next();
        }
    },
    {
        // MID 選擇頁
        path: '/:type(car|motor)/mid/confirm',
        name: 'MidConfirm',
        components: {
            default: MidConfirm,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 不能使用MID，踢回上一頁
            if (store.state.estimate.MidStatus <= 0) {
                return next(from);
            }

            next();
        }
    },
    {
        // MID 要保書預覽頁
        path: '/:type(car|motor)/mid/preview',
        name: 'MidPreview',
        components: {
            default: MidPreview,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 不能使用MID，踢回上一頁
            if (store.state.estimate.MidStatus <= 0) {
                return next(from);
            }

            next();
        }
    },
    {
        // 付款頁
        path: '/:type(car|motor)/checkout/payment',
        name: 'CarCheckoutPayment',
        components: {
            default: Payment,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 無付款方式，踢回上一頁
            if (!store.state.policy.payWays.length) {
                return next(from);
            }

            next();
        }
    },
    {
        // 結帳完成頁
        path: '/:type(car|motor)/checkout/finish',
        name: 'CarCheckoutFinish',
        components: {
            default: Finish,
            header: MainHeader
        },
        // 街口/全支付回來會沒登入
        // beforeEnter: (to, from, next) => {
        //     if (!store.getters['auth/loggedIn']) {
        //         store.commit('nav/setAll', {to: to, from: from, clear: true});
        //         return next({name: 'Login' });
        //     }

        //     next();
        // }
    },
    {
        // 結帳完成頁
        path: '/:type(car|motor)/checkout/pending',
        name: 'CarCheckoutPending',
        components: {
            default: Pending,
            header: MainHeader
        },
        // 街口/全支付回來會沒登入
        // beforeEnter: (to, from, next) => {
        //     if (!store.getters['auth/loggedIn']) {
        //         store.commit('nav/setAll', {to: to, from: from, clear: true});
        //         return next({name: 'Login' });
        //     }

        //     next();
        // }
    }
];